module.exports = "/images/aerial-6.jpg";